const canvas: HTMLCanvasElement = document.createElement('canvas');
canvas.style.position = 'absolute';
canvas.style.top = '-9999em';
canvas.style.display = 'none';
document.body.appendChild(canvas);

// fast way to measure text width
export const getTextWidth = (text: string, fontAttributes: string): number => {
  const context = canvas.getContext('2d');
  if (context) {
    context.font = fontAttributes;
    return context.measureText(text).width;
  }
  return 0;
};

/**
 * Two dashes to display in the UI for varied use cases. This lives outside of localization because the use case
 * should be constant across languages, for example when data is missing.
 *
 * UI Example:
 *
 * First Name:
 * --
 */
export const TWO_DASHES = '--';
export const ONE_DASH = '-';

const sanitiseRegexKey = (rawKey: string) => rawKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * This utility function is used to interpolate text with the given mapping.
 * @param text The input text with placeholders. E.g., 'one: ${cloak.one} - two:${cloak.two}'
 * @param mapping The mapping of keys to values. E.g., { 'cloak.one': 'value_1', 'cloak.two': 2 }
 * @returns The interpolated text. E.g., 'one: value_1 - two:2'
 */
export const interpolateText = (text: string, mapping: Record<string, number | string>) => {
  for (const [key, value] of Object.entries(mapping)) {
    const sanitisedKey = sanitiseRegexKey(key);
    text = text.replace(new RegExp(`\\$\\{${sanitisedKey}\\}`, 'g'), String(value));
  }
  // Check for unresolved patterns
  const unresolvedPatterns = text.match(/\$\{[^}]+\}/g);
  if (unresolvedPatterns) {
    console.warn(`Unresolved interpolation patterns: ${unresolvedPatterns.join(', ')}`);
    return undefined;
  }
  return text;
};
